import { ColumnSizingState } from '@tanstack/react-table';

// The pair's total never changes so the table keeps its overall width.
export const resizeColumnPair = (
  widths: ColumnSizingState,
  minSizes: ColumnSizingState,
  leftId: string,
  rightId: string,
  delta: number,
): ColumnSizingState => {
  const left = widths[leftId];
  const right = widths[rightId];
  const total = left + right;

  const leftMin = minSizes[leftId] ?? 0;
  const rightMin = minSizes[rightId] ?? 0;

  const nextLeft = Math.round(
    Math.min(Math.max(left + delta, leftMin), total - rightMin),
  );

  return {
    ...widths,
    [leftId]: nextLeft,
    [rightId]: total - nextLeft,
  };
};
